import styled from "styled-components";
import { colors } from "oolib";

export const StyledAudioEmbedPreview = styled.div`
    padding-top: 2rem;
`

export const StyledAudioEmbedPlayed = styled.div`
    padding-top: 56.25%;
    position: relative;
`
export const StyledAudioElement = styled.audio`
    width: 300px;
    height: 40px;
    background-color: ${colors.greyColor10};
    &::-webkit-media-controls-enclosure {
        border-radius: 0;
    }

    &::-webkit-media-controls-panel {
        background-color: ${colors.greyColor10};
    }
    /* -webkit-appearance: none; */
    
    /* Reset webkit border-radius to 0 */
    /* -webkit-border-radius: 0; */
`

export const StyledAudioPlayerWrapper = styled.div`
    display: flex;
    align-items: center;
    width: inherit;
    margin: ${({isInRTE}) => !isInRTE ? '1rem 0rem 2rem' : '0rem'};
`
